import { apiBindcustomerlist, apiCustomerInfo, apiZtInfoes, ReqBindCustomerList, ReqZtInfoes, ResBindCustomerList, ResZtInfoes, ResCustomerInfo, ZtInfo, apiGsLogin, GsLogin, CrsToken, commonLoginApi } from "@/api";
import { apiCwToken, ReqCwToken, apiZTBasicInfo, commonNewLoginApi } from "@/api";
import router from "@/router";
import { getSign } from "@/utils/sign";
import { defineStore } from "pinia";
import { useStore } from ".";
import { nextTick } from "vue";
const env = import.meta.env;

export interface MainState {
  ztList: ResZtInfoes[];
  nowZt: ResZtInfoes["ztID"]; // 当前账套
  latestZt: ResZtInfoes["ztID"]; // 最新账套
  customer: ResBindCustomerList[];
  nowCustomer: string;
  customerInfo: ResCustomerInfo;
  token: string; // 当前
  latestToken: string; // 最新
  gsToken: string; // 个税token
  ztInfo: ZtInfo;
  crs_token: string; // crs token
  caiJi_token: string; // 采集 token
}

export const useMainStore = defineStore({
  id: "useMainStore",
  state: (): MainState => ({
    ztList: [],
    nowZt: "",
    latestZt: "",
    customer: [],
    nowCustomer: "",
    customerInfo: {} as ResCustomerInfo,
    token: "",
    latestToken: "",
    gsToken: "",
    ztInfo: {} as ZtInfo,
    crs_token: "",
    caiJi_token: "",
  }),
  getters: {
    getZtList: (state: MainState) => state.ztList,
    getNowZt: (state: MainState) => state.ztList.find((n) => n.ztID == state.nowZt) as ResZtInfoes,
    getNewZt: (state: MainState) => state.ztList?.[0] as ResZtInfoes,
    getCustomer: (state: MainState) => state.customer,
    getNowCustomer: (state: MainState) => state.customer.find((n) => n.customerId == state.nowCustomer),
    getZtInfo: (state: MainState) => state.ztInfo,
    getSignalrArr: (state: MainState) => state.ztInfo?.outSignalrDomain || [],
    getZtToken:
      (state: MainState) =>
      (isLatest = false) =>
        isLatest ? state.latestToken : state.token,
    getGsToken: (state: MainState) => state.gsToken,
    getCrs_token: (state: MainState) => state.crs_token,
    getCaiJi_token: (state: MainState) => state.caiJi_token,
    /**
     * 财务登录
     * */
    getParams:
      (state: MainState) =>
      (isLatest: boolean): ReqCwToken => {
        const obj = useStore().getUserinfo;
        console.log(obj);
        const ZtID = isLatest ? state.latestZt : state.nowZt;
        return {
          key: "GetToken",
          client_secret: "0ca23d3c534cce8969b186a132d5a001ed23ee30057dc9f680c425075b30db80",
          grant_type: "password",
          client_id: "PC",
          ZtID,
          userName: obj.userName,
          companyId: obj.companyId,
          companyNumber: obj.companyNumber,
          userId: obj.userId,
          sign: getSign(ZtID),
          cType: 0,
          Password: obj.userId,
        };
      },
  },
  actions: {
    async setZtList(id: string) {
      const params: ReqZtInfoes = {
        customerID: id,
      };
      const { data } = await apiZtInfoes(params);
      this.ztList = data;
      if (data.length) this.setZt(data[0].ztID, true);
      else console.log("暂无账套信息");
    },
    setZt(id: string, isOne = false) {
      this.nowZt = id;
      this.token = "";
      if (isOne) {
        this.latestZt = id;
        this.latestToken = "";
        this.gsToken = "";
      }
    },
    /**
     * 设置token
     * @param isLatest 是否最新
     */
    async setToken(isLatest = false, isGs = false) {
      if (this.getZtToken(isLatest)) return;
      const store = useStore();
      try {
        store.setLoading(true);
        const params: ReqCwToken = this.getParams(isLatest);

        let formData = new FormData();
        Object.keys(params).forEach((key) => {
          formData.append(key, params[key as keyof ReqCwToken] as string);
        });
        const { access_token, token_type } = await apiCwToken(formData);
        const token = `${token_type} ${access_token}`;
        const { data } = await apiZTBasicInfo(token);
        if (isGs) await this.setGsToken();
        if (isLatest) this.latestToken = token;
        else this.token = token;

        this.ztInfo = data;
      } finally {
        store.setLoading(false);
      }
    },
    async setGsToken() {
      const store = useStore();
      const userinfo = store.getUserinfo;
      const params: GsLogin["ReqData"] = {
        serial: userinfo.companyNumber,
        userId: userinfo.taxUserId,
        userName: userinfo.taxUserName,
      };
      const { content } = await apiGsLogin(params);
      this.gsToken = content;
    },
    async setCustomer() {
      const store = useStore();
      const params: ReqBindCustomerList = {
        corpId: store.getCorpId,
        external_id: store.getExternal,
      };
      const { data } = await apiBindcustomerlist(params);
      if (data.length) {
        this.customer = data;
        this.setNowCustomer(data[0].customerId);
      }
      router.replace({ name: "main" });
    },
    async setNowCustomer(id: string) {
      const store = useStore();
      await store.setPower();
      if (id == this.nowCustomer) return;
      try {
        store.setLoading(true);
        await this.setZtList(id);
        this.nowCustomer = id;
        this.token = "";
        await this.setCustomerInfo();
      } finally {
        store.setLoading(false);
      }
      // await this.setToken();
    },
    async setCustomerInfo() {
      const store = useStore();
      try {
        store.setLoading(true);
        const params = { customerId: this.nowCustomer };
        const { data } = await apiCustomerInfo(params);
        this.customerInfo = data;
      } catch {
        this.customerInfo = {} as ResCustomerInfo;
      } finally {
        store.setLoading(false);
      }
    },
    async setCrs_token(fn: any) {
      const store = useStore();
      const userinfo = store.getUserinfo;
      console.log(userinfo, "userinfo");
      const params: CrsToken = {
        client_id: "crs_pc",
        grant_type: "password",
        route: "LoginCRS",
        client_secret: "2f23d472895bbab4ecce9f5c900051be",
        companyId: userinfo.companyId,
        compantType: "2",
        userId: userinfo.userId,
        userName: userinfo.userName || "系统管理员",
        versionType: this.getNowCustomer?.cType || 0,
      };

      let formData = new URLSearchParams();
      Object.keys(params).forEach((key) => {
        formData.append(key, params[key as keyof CrsToken] as string);
      });
      const { access_token } = await commonNewLoginApi(formData);
      this.crs_token = "Bearer " + access_token;
      nextTick(fn);
    },

    async setCaiJi_token(fn: any) {
      const store = useStore();
      const userinfo = store.getUserinfo;
      let getTokenParams = {
        serial: userinfo.companyNumber,
        userId: userinfo.userId,
        userName: userinfo.userName || "系统管理员", // 系统管理员 用户名称
        productVersion: 6,
      };
      const api6Login = await commonLoginApi(getTokenParams);
      console.log(api6Login, "api6Login");
      this.caiJi_token = api6Login.data.token;
      nextTick(fn());
    },
  },
  persist: [
    {
      storage: localStorage,
      paths: ["customerInfo"],
    },
  ],
});
